export const JobApplicationStateMachine = {
	interested: ['toInterview', 'rejected'],
	toInterview: ['offer', 'rejected'],
	offer: [],
	hired: [],
	rejected: []
};
